import type { CalculationType } from '../types/types'

/**
 * Whether Awell may republish this instrument's content.
 *
 * For a restricted instrument the API withholds the item text and the
 * documentation, and refuses to run it from here, so there is no form to render
 * and no documentation to show.
 *
 * A missing value means unrestricted. The API always sends the field and
 * reports `true` for a calculation with no licensing metadata of its own, so
 * absence means a cached or older response rather than a restriction, and
 * reading it as restricted would blank out calculations nobody meant to
 * withhold.
 */
export const isLicenseRestricted = (calculation?: CalculationType): boolean =>
  calculation?.content_available === false
